import React from "react";
import DOMPurify from "dompurify";
import { Box, Typography } from "@mui/material";
import { LabelFieldBox } from "../components/postLogin/MyLicenses";

interface DescriptionViewerProps {
  value: string;
  height?: number | string;
  width?: number | string;
}

const isHTMLString = (str: string) => /<\/?[a-z][\s\S]*>/i.test(str);

const DescriptionViewer: React.FC<DescriptionViewerProps> = ({
  value,
  height = 'auto', // default fixed height
  width = "100%", // default full width
}) => {
  if (!value) return null;

  if (isHTMLString(value)) {
    return (
        <><LabelFieldBox
            label={"Description"}
            value={' '}
            />
        <Box
            sx={{
              transform: "scale(0.9)", // shrink content
              transformOrigin: "top left", // scale from top-left corner
              width: "100%", // compensate scaling (important for layout)
            }}
          >

        <Box
        sx={(theme) => ({
          height,
          width,
          overflowY: "auto",
          overflowX: "hidden",
          backgroundColor: "inherit",
          border: `1px solid ${theme.palette.divider}`,
          borderRadius: 1,
          padding: 1,

          // ✅ ensure text respects theme
          "& .elementToProof": {
            fontSize: "14px",
            lineHeight: 1.5,
            color: `${theme.palette.text.primary} !important`,
            backgroundColor: "transparent !important",
            fontFamily: theme.typography.fontFamily,
          },

          "& .elementToProof span, & .elementToProof strong": {
            color: `${theme.palette.text.primary} !important`,
            backgroundColor: "transparent !important",
          },

          // ✅ make images responsive inside HTML
          "& img": {
            maxWidth: "100%",
            height: "auto",
            display: "block",
            marginTop: theme.spacing(1),
            marginBottom: theme.spacing(1),
          },

          // ✅ paragraphs spacing
          "& p": {
            margin: `${theme.spacing(1)} 0`,
          },
        })}
        dangerouslySetInnerHTML={{
          __html: DOMPurify.sanitize(value, {
            ADD_TAGS: ["img", "span", "p", "strong"],
            ADD_ATTR: ["style", "size", "data-*", "src"],
          }),
        }}
      />
          </Box>
       
         </>

     
    );
  }

  return (
  

    <LabelFieldBox
        label="Description"
        showMore
        value={value}
        />
  );
};

export default DescriptionViewer;
